import postsLoadMore from "../components/postsLoadMore";

export default () => {
    console.log('search');
    postsLoadMore();
}